import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {SpecialScheduleEntityModel} from "../special-schedule-entity.model";
import {SpecialScheduleData} from "../special-schedule.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-special-schedule-edit-page",
    templateUrl: "./special-schedule-edit-page.component.html",
    providers: [provideEntityModel(SpecialScheduleEntityModel)]
})
export class SpecialScheduleEditPageComponent extends AbstractEditPage implements OnInit {

    specialLocked: boolean = false;

    constructor(public model: SpecialScheduleEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    get data(): SpecialScheduleData {
        return <SpecialScheduleData>this.model.data;
    }

    ngOnInit(): void {
        if (this.editPageComponent.stackedPageContextService && this.editPageComponent.stackedPageContextService.params.parentEntity) {
            this.data.special = this.editPageComponent.stackedPageContextService.params.parentEntity;
            this.specialLocked = true;
        }
    }
}
